// TODO turn separate configs into single config. eg. translation service

import type { SiteIsoEnum, SiteLangEnum } from "@kunduz/utility-common";

/**
 * used by question indexing elasticsearch
 * @param lang
 * @returns
 */
export function convertLangToXLocale(
  lang: "tr" | "en" | string,
): "tr_tr" | "en_us" {
  const _dict = {
    tr: "tr_tr",
    en: "en_us",
  };

  return _dict[lang];
}

/**
 * used by question indexing rest api
 * @param lang
 * @returns
 */
export function convertLangToKZISO(lang: SiteLangEnum): SiteIsoEnum {
  const _dict = {
    tr: "TR",
    en: "US",
    "en-US": "US",
  };

  return _dict[lang];
}

/**
 * used by blog
 * @param lang
 * @returns
 */
export function convertLangToGraphqlLocale(lang: SiteLangEnum): "tr_tr" | "en" {
  const _dict: Record<SiteLangEnum, "tr_tr" | "en"> = {
    tr: "tr_tr",
    "tr-TR": "tr_tr",
    en: "en",
    "en-US": "en",
    "en-EG": "en",
    "en-AE": "en",
  };

  return _dict[lang];
}
